import React  from 'react';
import './App.css';
import './Report.css';
import ReportLang from './ReportLang.json';

class ReportBookSource extends React.Component {

	constructor(props) {

		super(props);
		
		this.state = {
			innerWidth: 0,
			innerHeight: 0,
			currentYear: 0,
			year0: 0,
			year1: 0,
			selectedYear0: true,
			selectedYear1: false,
			agencyArray: null,
			jsonObj0: null,
			jsonObj1: null,
			jsonObj: null,
		};

		this.updateDimensions = this.updateDimensions.bind(this);
	}

	async componentDidMount() {

		this.updateDimensions();
		window.addEventListener('resize', this.updateDimensions);
		var dateObj = new Date();
		var currentYear = dateObj.getFullYear();
		var nextYear = currentYear + 1;
		this.setState({
			currentYear: currentYear,
			year0: currentYear,
			year1: nextYear,
		});

		var selectedYear0 = true;
		var selectedYear1 = false;
		this.handleSelectedYearChange(currentYear, nextYear, selectedYear0, selectedYear1);
		var dashboardID = this.props.dashboardID;
		if (dashboardID > 0) {
			//this.serverGetDashboardVariableList(dashboardID);
			//this.serverDataGetFileList(dashboardID);
		}
	}

	componentWillUnmount() {
		document.removeEventListener('resize', this.updateDimensions, true);
	};
	
	updateDimensions = () => {
		this.setState({ innerWidth: window.innerWidth, innerHeight: window.innerHeight });
	};
	
	async serverDataGetTextFile(filename) {
		
		var baseURLAPI = this.props.baseURLAPI;
		var dashboardID = this.props.dashboardID;
		var dataUrl = "/dashboard/" + dashboardID + "/bookSource/" + filename
		var url = baseURLAPI + "/datagettextfile?url=" +  encodeURIComponent(dataUrl);
		
		var res = await fetch(url);
		var textResponse = await res.text();

		if (filename.includes("current")) {
			//this.calcAverageMonthYear(jsonObj, true);
		} else {
			//this.calcAverageMonthYear(jsonObj, false);
		}

		return textResponse;
	}
	
	async serverDataGetFileList(dashboardID) {

		var baseURLAPI = this.props.baseURLAPI;
		var dataUrl = "/dashboard/" + dashboardID + "/roomsWholeYear"
		var url = baseURLAPI + "/datagetfilelist?url=" +  encodeURIComponent(dataUrl);
		
		var jsonObj = null;
		
		try {
			var res = await fetch(url);
			jsonObj = await res.json();
		} catch (err) {
		}

		this.setState({dataFileListObj: jsonObj});
	}
	
	findItemByAgencyName(jsonObj, agencyName1) {
		
		if (jsonObj === null) {
			return jsonObj;
		}
		
		var i;
		var agencyName2;
		var itemObj;
		
		for(i=0; i<jsonObj.length; i++) {
			itemObj = jsonObj[i];
			agencyName2 = itemObj.agency;
			if (agencyName1 === agencyName2) {
				return itemObj;
			}
		}
		
		return null;
	}
	
	getAgencyArray(jsonObj0, jsonObj1) {

		var i;
		var agencyName;
		var itemObj;
		var foundYN;
		var agencyArray = [];

		if (jsonObj0 !== null) {
			for(i=0; i<jsonObj0.length; i++) {
				itemObj = jsonObj0[i];
				agencyName = itemObj.agency;
				agencyArray.push(agencyName);
			}
		}

		if (jsonObj1 !== null) {
			for(i=0; i<jsonObj1.length; i++) {
				itemObj = jsonObj1[i];
				agencyName = itemObj.agency;
				foundYN = agencyArray.includes(agencyName);
				if (!foundYN) {
					agencyArray.push(agencyName);
				}
			}
		}

		return agencyArray;
	}

	
	async handleSelectedYearChange(year0, year1, selectedYear0, selectedYear1) {

		var jsonObj0 = null;
		var jsonObj1 = null;

		var filename;
		var reponseText;

		if (selectedYear0) {
			filename = "current-" + year0 + ".json";
			reponseText = await this.serverDataGetTextFile(filename);
			jsonObj0 = JSON.parse(reponseText);
		}
	
		if (selectedYear1) {
			filename = "current-" + year1 + ".json";
			reponseText = await this.serverDataGetTextFile(filename);
			jsonObj1 = JSON.parse(reponseText);
		}
		
		var agencyArray = this.getAgencyArray(jsonObj0, jsonObj1);
	
		this.setState({
			agencyArray: agencyArray,
			jsonObj0: jsonObj0,
			jsonObj1: jsonObj1,
		});
	}
	
	async handleOnClickYear(yearIndex) {

		var selectedYear0 = this.state.selectedYear0;
		var selectedYear1 = this.state.selectedYear1;

		if (yearIndex === 0) {
			selectedYear0 = !selectedYear0;
		}

		if (yearIndex === 1) {
			selectedYear1 = !selectedYear1;
		}
		
		if ((!selectedYear0) && (!selectedYear1)) {
			if (yearIndex === 0) {
				selectedYear0 = true;
			} else {
				selectedYear1 = true;
			}
		}

		this.setState({
			selectedYear0: selectedYear0,
			selectedYear1: selectedYear1,
		});

		this.handleSelectedYearChange(this.state.year0, this.state.year1, selectedYear0, selectedYear1);
	}
	
	renderNoReport() {

		var dashboardName = this.props.dashboardName;
		var string1 = this.props.getLang(ReportLang, "noOccupancyReportForProperty");
		var string2 = string1 + " " + dashboardName;

		return (
			<div>
				<div style={{height: "20px"}}></div>
				{string2}
				<div style={{height: "500px"}}></div>
			</div>
		);
	}

	renderHeaderOneYear(year, yearIndex, selectedYN) {
		
		var className = "";
		var key = "header-" + yearIndex;
		
		if (selectedYN) {
			if (yearIndex === 0) {
				className = "ReportBookSourceYearOneYearSelected0";
			} else {
				className = "ReportBookSourceYearOneYearSelected1";
			}
		} else {
			className = "ReportBookSourceYearOneYear";
		}
		
		return (
			<div key={key} className={className} onClick={() => this.handleOnClickYear(yearIndex)}>{year}</div>
		);
	}

	renderHeader() {
		
		var year0 = this.state.year0;
		var year1 = this.state.year1;
		var selectedYear0 = this.state.selectedYear0;
		var selectedYear1 = this.state.selectedYear1;
		var jsxCode;
		var jsxArray = [];
		var yearIndex;

		yearIndex = 0;
		jsxCode = this.renderHeaderOneYear(year0, yearIndex, selectedYear0)
		jsxArray.push(jsxCode);

		yearIndex = 1;
		jsxCode = this.renderHeaderOneYear(year1, yearIndex, selectedYear1)
		jsxArray.push(jsxCode);

		return (
			<div>
				<div className="ReportBookSourceYearContainer">{jsxArray}</div>
			</div>
		);

	}

	renderOneAgency(agencyIndex, agencyName) {
		
		var jsonObj0 = this.state.jsonObj0;
		var itemObj0 = this.findItemByAgencyName(jsonObj0, agencyName);
		var roomsArray0 = null;
		var roomRevenueArray0 = null;
		
		if (itemObj0 !== null) {
			roomsArray0 = itemObj0.rooms;
			roomRevenueArray0 = itemObj0.roomRevenue;
		}

		var jsonObj1 = this.state.jsonObj1;
		var itemObj1 = this.findItemByAgencyName(jsonObj1, agencyName);
		var roomsArray1 = null;
		var roomRevenueArray1 = null;
		
		if (itemObj1 !== null) {
			roomsArray1 = itemObj1.rooms;
			roomRevenueArray1 = itemObj1.roomRevenue;
		}

		var i;
		var key;
		var room;
		var revenue;
		var revenueString;
		var price;
		var jsxCodePart0;
		var jsxCodePart1;
		var jsxCode;
		var jsxArray = [];
		var displayString;
		var roomTotal0 = 0;
		var revenueTotal0 = 0;
		var roomTotal1 = 0;
		var revenueTotal1 = 0;

		for(i=0; i<12; i++) {

			if (itemObj0 === null) {
				jsxCodePart0 = null;
			} else {
				room = roomsArray0[i];
				if (room === 0) {
					jsxCodePart0 = null;
				} else {
					revenue = roomRevenueArray0[i];
					roomTotal0 += room;
					revenueTotal0 += revenue;
					revenueString = this.props.getEURString(revenue, 0);
					price = revenue / room;
					displayString = room + " x " + Math.round(price);
					jsxCodePart0 = (<div className="ReportBookSourceMonthItemPart0">{displayString}<br/>{revenueString}</div>);
				}
			}

			if (itemObj1 === null) {
				jsxCodePart1 = null;
			} else {
				room = roomsArray1[i];
				if (room === 0) {
					jsxCodePart1 = null;
				} else {
					revenue = roomRevenueArray1[i];
					roomTotal1 += room;
					revenueTotal1 += revenue;
					revenueString = this.props.getEURString(revenue, 0);
					price = revenue / room;
					displayString = room + " x " + Math.round(price);
					jsxCodePart1 = (<div className="ReportBookSourceMonthItemPart1">{displayString}<br/>{revenueString}</div>);
				}
			}

			if ((itemObj0 !== null) && (itemObj1 !== null)) {
				if (jsxCodePart0 === null) {
					jsxCodePart0 = (<div>&nbsp;<br/>&nbsp;</div>);
				}
				if (jsxCodePart1 === null) {
					jsxCodePart1 = (<div>&nbsp;<br/>&nbsp;</div>);
				}
			}

			key = "item-" + agencyIndex + "-" + i;
			jsxCode = (<td key={key} className="ReportBookSourceMonthItem">{jsxCodePart0}{jsxCodePart1}</td>);
			jsxArray.push(jsxCode);
		}
		
		key = "item-" + agencyIndex + "-total";

		if (itemObj0 === null) {
			jsxCodePart0 = null;
		} else {
			if (roomTotal0 === 0) {
				jsxCodePart0 = null;
			} else {
				revenueString = this.props.getEURString(revenueTotal0, 0);
				price = revenueTotal0 / roomTotal0;
				displayString = roomTotal0 + " x " + Math.round(price);
				jsxCodePart0 = (<div className="ReportBookSourceMonthItemPart0">{displayString}<br/><b>{revenueString}</b></div>);
			}
		}
		
		if (itemObj1 === null) {
			jsxCodePart1 = null;
		} else {
			if (roomTotal1 === 0) {
				jsxCodePart1 = null;
			} else {
				revenueString = this.props.getEURString(revenueTotal1, 0);
				price = revenueTotal1 / roomTotal1;
				displayString = roomTotal1 + " x " + Math.round(price);
				jsxCodePart1 = (<div className="ReportBookSourceMonthItemPart1">{displayString}<br/><b>{revenueString}</b></div>);
			}
		}
		
		jsxCode = (<td key={key} className="ReportBookSourceMonthItem">{jsxCodePart0}{jsxCodePart1}</td>);

		var trClassName = "ReportTableLine1";
		if (agencyIndex % 2 === 0) {
			trClassName = "ReportTableLine2";
		}

		return (
			<tr className={trClassName}>
				<td className="ReportBookSourceAgencyItem">{agencyName}</td>
				{jsxArray}
				{jsxCode}
			</tr>
		);
	}
	
	renderBottomTotals() {
		
		var jsonObj0 = this.state.jsonObj0;
		var jsonObj1 = this.state.jsonObj1;

		var i;
		var j;
		var itemObj;
		var roomsArray = null;
		var roomRevenueArray = null;				
		var roomMonthArray0 = null;
		var revenueMonthArray0 = null;
		var roomMonthArray1 = null;
		var revenueMonthArray1 = null;
		var roomYearTotal0 = 0;
		var revenueYearTotal0 = 0;
		var roomYearTotal1 = 0;
		var revenueYearTotal1 = 0;

		if (jsonObj0 !== null) {

			roomMonthArray0 = [];
			revenueMonthArray0 = [];

			for(i=0; i<12; i++) {
				roomMonthArray0.push(0);
				revenueMonthArray0.push(0);
			}

			for(i=0; i<jsonObj0.length; i++) {
				itemObj = jsonObj0[i];
				roomsArray = itemObj.rooms;
				roomRevenueArray = itemObj.roomRevenue;
				for(j=0; j<12; j++) {
					roomMonthArray0[j] += roomsArray[j];
					revenueMonthArray0[j] += roomRevenueArray[j];
					roomYearTotal0 += roomsArray[j];
					revenueYearTotal0 += roomRevenueArray[j];
				}
			}
		}

		if (jsonObj1 !== null) {

			roomMonthArray1 = [];
			revenueMonthArray1 = [];

			for(i=0; i<12; i++) {
				roomMonthArray1.push(0);
				revenueMonthArray1.push(0);
			}

			for(i=0; i<jsonObj1.length; i++) {
				itemObj = jsonObj1[i];
				roomsArray = itemObj.rooms;
				roomRevenueArray = itemObj.roomRevenue;
				for(j=0; j<12; j++) {
					roomMonthArray1[j] += roomsArray[j];
					revenueMonthArray1[j] += roomRevenueArray[j];
					roomYearTotal1 += roomsArray[j];
					revenueYearTotal1 += roomRevenueArray[j];
				}
			}
		}

		var key;
		var room;
		var revenue;
		var revenueString;
		var price;
		var displayString;
		var jsxCodePart0;
		var jsxCodePart1;
		var jsxCode;
		var jsxArray = [];

		for(i=0; i<12; i++) {

			if (jsonObj0 === null) {
				jsxCodePart0 = null;
			} else {
				room = roomMonthArray0[i];
				if (room === 0) {
					jsxCodePart0 = null;
				} else {
					revenue = revenueMonthArray0[i];
					revenueString = this.props.getEURString(revenue, 0);
					price = revenue / room;
					displayString = room + " x " + Math.round(price);
					jsxCodePart0 = (<div className="ReportBookSourceMonthItemPart0">{displayString}<br/><b>{revenueString}</b></div>);
				}
			}

			if (jsonObj1 === null) {
				jsxCodePart1 = null;
			} else {
				room = roomMonthArray1[i];
				if (room === 0) {
					jsxCodePart1 = null;
				} else {
					revenue = revenueMonthArray1[i];
					revenueString = this.props.getEURString(revenue, 0);
					price = revenue / room;
					displayString = room + " x " + Math.round(price);
					jsxCodePart1 = (<div className="ReportBookSourceMonthItemPart1">{displayString}<br/><b>{revenueString}</b></div>);
				}
			}

			key = "total-" + i;
			jsxCode = (<td key={key} className="ReportBookSourceMonthItem">{jsxCodePart0}{jsxCodePart1}</td>);
			jsxArray.push(jsxCode);
		}

		if (roomYearTotal0 === 0) {
			jsxCodePart0 = null;
		} else {
			revenueString = this.props.getEURString(revenueYearTotal0, 0);
			price = revenueYearTotal0 / roomYearTotal0;
			displayString = roomYearTotal0 + " x " + Math.round(price);
			jsxCodePart0 = (<div className="ReportBookSourceMonthItemPart0">{displayString}<br/><b>{revenueString}</b></div>);
		}

		if (roomYearTotal1 === 0) {
			jsxCodePart1 = null;
		} else {
			revenueString = this.props.getEURString(revenueYearTotal1, 0);
			price = revenueYearTotal1 / roomYearTotal1;
			displayString = roomYearTotal1 + " x " + Math.round(price);
			jsxCodePart1 = (<div className="ReportBookSourceMonthItemPart1">{displayString}<br/><b>{revenueString}</b></div>);
		}
		
		key = "bottom-total";
		jsxCode = (<td key={key} className="ReportBookSourceMonthItem">{jsxCodePart0}{jsxCodePart1}</td>);

		return (
			<tr className="ReportTableLine3">
				<td className="ReportBookSourceAgencyHeader">{this.props.getLang(ReportLang, "total")}</td>
				{jsxArray}
				{jsxCode}
			</tr>
		);
	}
	
	renderAllAgencies() {
		
		var agencyArray = this.state.agencyArray;
		if (agencyArray === null) {
			return;
		}
		
		var i;
		var j;
		var itemObj;
		var key;
		var month;
		var monthString;
		var jsxCode;
		var jsxArray1 = [];
		var jsxArray2 = [];

		for(i=0; i<12; i++) {
			month = i + 1;
			monthString = this.props.getMonthString(month);
			key = "header-" + i;
			jsxCode = (<th key={key} className="ReportBookSourceMonthHeader">{monthString}</th>);
			jsxArray1.push(jsxCode);
		}

		var agencyName;

		for(i=0; i<agencyArray.length; i++) {
			agencyName = agencyArray[i];
			jsxCode = this.renderOneAgency(i, agencyName);
			jsxArray2.push(jsxCode);
		}
		
		var jsxArray3 = this.renderBottomTotals();
		
		return (
			<div>
				<table>
					<thead>
						<tr>
							<th className="ReportBookSourceAgencyHeader">{this.props.getLang(ReportLang, "agency")}</th>
							{jsxArray1}
							<th key={key} className="ReportBookSourceMonthHeader">{this.props.getLang(ReportLang, "total")}</th>
						</tr>
					</thead>
					<tbody>
						{jsxArray2}
						{jsxArray3}
					</tbody>
				</table>
			</div>
		);
	}
	
	renderBookSource() {

		return (
			<div>
				<center>
				<div style={{height: "20px"}}></div>
				{this.renderHeader()}
				<div style={{height: "10px"}}></div>
				{this.renderAllAgencies()}
				<div style={{height: "30px"}}></div>
				</center>
			</div>
		);
	}
	
	render() {

		var jsonObj = this.state.jsonObj;
		if (jsonObj === null) {
			//return;			
		}
		
		//var tab = this.props.tab;
		return this.renderBookSource();
	}
}

export default ReportBookSource;

